import { apiSlice } from "../../../apiSlice";

export const itemdoxxApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    saveDocTransporteByDo: builder.mutation({
      query: ({ DOCNROXX, body }) => ({
        url: `/Modimpxx/Documexx/Itemdoxx/saveDocTransporteByDo/${DOCNROXX}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Create"],
    }),
    saveInvoiceByDo: builder.mutation({
      query: ({ DOCNROXX, body }) => ({
        url: `/Modimpxx/Documexx/Itemdoxx/saveInvoiceByDo/${DOCNROXX}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Create"],
    }),
    getDocTransporteByDo: builder.mutation({
      query: ({ DOCNROXX }) => ({
        url: `/Modimpxx/Documexx/Itemdoxx/getDocTransporteByDo/${DOCNROXX}`,
        method: "GET",
      }),
    }),
    restoreTotalNat: builder.mutation({
      query: ({ DOCNROXX }) => ({
        url: `/Modimpxx/Documexx/Itemdoxx/restoreTotalNat/${DOCNROXX}`,
        method: "POST",
      }),
    }),
    //Resumen de como van los items (solo lectura, ventana independiente)
    getResumenItems: builder.query({
      query: (DOCNROXX) => ({
        url: `/Modimpxx/Documexx/Itemdoxx/resumen/${DOCNROXX}`,
        method: "GET",
      }),
      //El resumen se vuelve a leer cuando cambia cualquier resultado clave (seriales, registro, ítems): antes quedaba en caché (Diego 2026-10-16)
      providesTags: ["keyResultImpo"],
    }),
    getParcialContext: builder.mutation({
      query: ({ DOCNROXX }) => ({
        url: `/Modimpxx/Documexx/Itemdoxx/getParcialContext/${DOCNROXX}`,
        method: "GET",
      }),
    }),
    getInvoicesByDo: builder.mutation({
      query: ({ DOCNROXX }) => ({
        url: `/Modimpxx/Documexx/Itemdoxx/getInvoiceByDo/${DOCNROXX}`,
        method: "GET",
      }),
    }),
    getDataImpoByDo: builder.mutation({
      query: ({ DOCNROXX }) => ({
        url: `/Modimpxx/Documexx/Itemdoxx/getDataImpoByDo/${DOCNROXX}`,
        method: "GET",
      }),
    }),
    saveComplementData: builder.mutation({
      query: (body) => ({
        url: "Modimpxx/Documexx/Itemdoxx/saveComplementData",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Create", "keyResultImpo"],
    }),
    getInvoices: builder.mutation({
      query: ({ filters = {}, page = 1, perPage = 10 }) => {
        const params = {
          page,
          perPage,
        };
        Object.entries(filters).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== "") {
            params[`filters[${key}]`] = value;
          }
        });

        return {
          url: `/Modimpxx/Documexx/Itemdoxx/getInvoice`,
          method: "GET",
          params,
        };
      },
    }),
    getInvoicesWoPage: builder.mutation({
      query: ({ filters = {} }) => {
        const params = {};
        Object.entries(filters).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== "") {
            params[`filters[${key}]`] = value;
          }
        });

        return {
          url: `/Modimpxx/Documexx/Itemdoxx/getInvoice`,
          method: "GET",
          params,
        };
      },
    }),
    getComplementDataPaged: builder.mutation({
      query: ({ filters = {}, page = 1, perPage = 50 }) => {
        const params = { page, perPage };
        Object.entries(filters).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== "") {
            params[`filters[${key}]`] = value;
          }
        });
        return {
          url: `/Modimpxx/Documexx/Itemdoxx/getComplementDataPaged`,
          method: "GET",
          params,
        };
      },
    }),
    getModalitiesByClientProvider: builder.mutation({
      query: ({ CLIIDXXX, IDPROXXX }) => ({
        url: `/Modimpxx/Documexx/Itemdoxx/getModalitiesByProvider/${CLIIDXXX}/${IDPROXXX}`,
        method: "GET",
      }),
    }),
    isRCComplete: builder.mutation({
      query: ({ DOCNROXX }) => ({
        url: `/Modimpxx/Documexx/Itemdoxx/isRCComplete/${DOCNROXX}`,
        method: "GET",
      }),
    }),
    saveGeneralData: builder.mutation({
      query: (body) => ({
        url: "Modimpxx/Documexx/Itemdoxx/saveGeneralData",
        method: "POST",
        body,
      }),
      invalidatesTags: ["keyResultImpo"],
    }),
    getDescriptorsByProduct: builder.mutation({
      query: ({ filters = {} }) => {
        const params = {};
        Object.entries(filters).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== "") {
            params[`filters[${key}]`] = value;
          }
        });

        return {
          url: `/Modimpxx/Documexx/Itemdoxx/getDescriptorsByProduct`,
          method: "GET",
          params,
        };
      },
    }),
    saveDescriptorsByProduct: builder.mutation({
      query: ({ DOCNROXX, body }) => ({
        url: `/Modimpxx/Documexx/Itemdoxx/saveDescriptors/${DOCNROXX}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Create", "keyResultImpo"],
    }),
    saveSerialByProduct: builder.mutation({
      query: ({ body }) => ({
        url: `/Modimpxx/Documexx/Itemdoxx/saveSeriales`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["Create"],
    }),
    checkDuplicatedSerialsByProduct: builder.mutation({
      query: ({ body }) => ({
        url: `/Modimpxx/Documexx/Itemdoxx/checkDuplicatedSerials`,
        method: "POST",
        body,
      }),
    }),
    cleanSerialesByProduct: builder.mutation({
      query: ({ DOCNROXX, body }) => ({
        url: `/Modimpxx/Documexx/Itemdoxx/cleanSeriales/${DOCNROXX}`,
        method: "DELETE",
        body,
      }),
    }),
    getCountSerialsByDescriptor: builder.mutation({
      query: (params) => ({
        url: `/Modimpxx/Documexx/Itemdoxx/getCountSerialsByDescriptor`,
        method: "GET",
        params,
      }),
    }),
    downloadSerialsByDescriptor: builder.mutation({
      query: (params) => ({
        url: `/Modimpxx/Documexx/Itemdoxx/downloadSerial`,
        method: "GET",
        params,
      }),
    }),
    getDuplicatedSerialsByDescriptor: builder.mutation({
      query: (params) => ({
        url: `/Modimpxx/Documexx/Itemdoxx/getDuplicatedSerials`,
        method: "GET",
        params,
      }),
    }),
    updateSerial: builder.mutation({
      query: ({ DOCNROXX, body }) => ({
        url: `/Modimpxx/Documexx/Itemdoxx/updateSerial/${DOCNROXX}`,
        method: "PUT",
        body,
      }),
    }),
    setSerialsPending: builder.mutation({
      query: ({ DOCNROXX, body }) => ({
        url: `/Modimpxx/Documexx/Itemdoxx/setSerialsPending/${DOCNROXX}`,
        method: "PUT",
        body,
      }),
    }),
    getShortLinkByDoctra: builder.query({
      query: (params) => ({
        url: "Modimpxx/Documexx/Itemdoxx/getShortLinkByDoctra",
        params,
      }),
    }),
    getPackagesByProvider: builder.mutation({
      query: ({ CLIIDXXX, IDPROXXX }) => ({
        url: `/Modimpxx/Documexx/Itemdoxx/getPackagesByProvider/${CLIIDXXX}/${IDPROXXX}`,
        method: "GET",
      }),
    }),
    getAvailableRegisters: builder.mutation({
      query: ({ DOCNROXX }) => ({
        url: `/Modimpxx/Documexx/Itemdoxx/getAvailableRegisters/${DOCNROXX}`,
        method: "GET",
      }),
    }),
    getRegistersWithBalance: builder.query({
      query: ({ DOCNROXX }) => ({
        url: `/Modimpxx/Documexx/Itemdoxx/getRegistersWithBalance/${DOCNROXX}`,
        method: "GET",
      }),
    }),
    assignRegister: builder.mutation({
      query: (body) => ({
        url: `/Modimpxx/Documexx/Itemdoxx/assignRegister`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["Create", "keyResultImpo"],
    }),
    getAdditionalDescriptors: builder.mutation({
      query: ({ CLIIDXXX, IDPROXXX, PROIDXXX }) => ({
        url: `/Modimpxx/Documexx/Itemdoxx/getAdditionalDescriptors/${CLIIDXXX}/${IDPROXXX}/${PROIDXXX}`,
        method: "GET",
      }),
    }),
    getVallejoPrograms: builder.mutation({
      query: ({ CLIIDXXX }) => ({
        url: `/Modimpxx/Documexx/Itemdoxx/getVallejoPrograms/${CLIIDXXX}`,
        method: "GET",
      }),
    }),
    getJurisdictions: builder.mutation({
      query: () => ({
        url: `/Modimpxx/Documexx/Itemdoxx/getJurisdictions`,
        method: "GET",
      }),
    }),
    getModalities: builder.mutation({
      query: () => ({
        url: `/Modimpxx/Documexx/Itemdoxx/getModalities`,
        method: "GET",
      }),
    }),
    getImportTypes: builder.mutation({
      query: () => ({
        url: `/Modimpxx/Documexx/Itemdoxx/getImportTypes`,
        method: "GET",
      }),
    }),
    downloadDescriptores: builder.mutation({
      query: ({ DOCNROXX }) => ({
        url: `/Modimpxx/Documexx/Itemdoxx/downloadDescriptores/${DOCNROXX}`,
        method: "GET",
      }),
    }),
    uploadDescriptores: builder.mutation({
      query: ({ body }) => ({
        url: `/Modimpxx/Documexx/Itemdoxx/uploadDescriptores`,
        method: "POST",
        body,
        formData: true,
      }),
    }),
    downloadSeriales: builder.mutation({
      query: ({ DOCNROXX }) => ({
        url: `/Modimpxx/Documexx/Itemdoxx/downloadSeriales/${DOCNROXX}`,
        method: "GET",
      }),
    }),
    uploadSeriales: builder.mutation({
      query: ({ body }) => ({
        url: `/Modimpxx/Documexx/Itemdoxx/uploadSeriales`,
        method: "POST",
        body,
        formData: true,
      }),
    }),
    getMdfvByItem: builder.mutation({
      query: ({ filters = {} }) => {
        const params = {};
        Object.entries(filters).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== "") {
            params[`filters[${key}]`] = value;
          }
        });
        return {
          url: `/Modimpxx/Documexx/Itemdoxx/getMdfvByItem`,
          method: "GET",
          params,
        };
      },
    }),
    getMdfvHistorial: builder.mutation({
      query: (params) => ({
        url: `/Modimpxx/Documexx/Itemdoxx/getMdfvHistorial`,
        method: "GET",
        params,
      }),
    }),
    saveMdfvValues: builder.mutation({
      query: (body) => ({
        url: `/Modimpxx/Documexx/Itemdoxx/saveMdfvValues`,
        method: "POST",
        body,
      }),
    }),
    saveSerialVarByProduct: builder.mutation({
      query: ({ body }) => ({
        url: `/Modimpxx/Documexx/Itemdoxx/saveSerialesVar`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["Create"],
    }),
    checkDuplicatedSerialsVarByProduct: builder.mutation({
      query: ({ body }) => ({
        url: `/Modimpxx/Documexx/Itemdoxx/checkDuplicatedSerialsVar`,
        method: "POST",
        body,
      }),
    }),
    cleanSerialesVarByProduct: builder.mutation({
      query: ({ DOCNROXX, body }) => ({
        url: `/Modimpxx/Documexx/Itemdoxx/cleanSerialesVar/${DOCNROXX}`,
        method: "DELETE",
        body,
      }),
    }),
    getCountSerialsVar: builder.mutation({
      query: (params) => ({
        url: `/Modimpxx/Documexx/Itemdoxx/getCountSerialsVar`,
        method: "GET",
        params,
      }),
    }),
    downloadSerialsVar: builder.mutation({
      query: (params) => ({
        url: `/Modimpxx/Documexx/Itemdoxx/downloadSerialVar`,
        method: "GET",
        params,
      }),
    }),
    getDuplicatedSerialsVar: builder.mutation({
      query: (params) => ({
        url: `/Modimpxx/Documexx/Itemdoxx/getDuplicatedSerialsVar`,
        method: "GET",
        params,
      }),
    }),
    updateSerialVar: builder.mutation({
      query: ({ DOCNROXX, body }) => ({
        url: `/Modimpxx/Documexx/Itemdoxx/updateSerialVar/${DOCNROXX}`,
        method: "PUT",
        body,
      }),
    }),
    setSerialsPendingVar: builder.mutation({
      query: ({ DOCNROXX, body }) => ({
        url: `/Modimpxx/Documexx/Itemdoxx/setSerialsPendingVar/${DOCNROXX}`,
        method: "PUT",
        body,
      }),
    }),
  }),
});

export const {
  useGetResumenItemsQuery,
  useSaveDocTransporteByDoMutation,
  useSaveInvoiceByDoMutation,
  useGetDocTransporteByDoMutation,
  useRestoreTotalNatMutation,
  useGetParcialContextMutation,
  useGetInvoicesByDoMutation,
  useGetInvoicesMutation,
  useGetInvoicesWoPageMutation,
  useGetComplementDataPagedMutation,
  useSaveComplementDataMutation,
  useGetModalitiesByClientProviderMutation,
  useIsRCCompleteMutation,
  useSaveGeneralDataMutation,
  useGetDescriptorsByProductMutation,
  useSaveDescriptorsByProductMutation,
  useSaveSerialByProductMutation,
  useCheckDuplicatedSerialsByProductMutation,
  useCleanSerialesByProductMutation,
  useGetCountSerialsByDescriptorMutation,
  useDownloadSerialsByDescriptorMutation,
  useGetDuplicatedSerialsByDescriptorMutation,
  useUpdateSerialMutation,
  useSetSerialsPendingMutation,
  useLazyGetShortLinkByDoctraQuery,
  useGetDataImpoByDoMutation,
  useGetPackagesByProviderMutation,
  useGetAvailableRegistersMutation,
  useAssignRegisterMutation,
  useGetRegistersWithBalanceQuery,
  useGetAdditionalDescriptorsMutation,
  useGetVallejoProgramsMutation,
  useGetJurisdictionsMutation,
  useGetImportTypesMutation,
  useGetModalitiesMutation,
  useDownloadDescriptoresMutation,
  useUploadDescriptoresMutation,
  useDownloadSerialesMutation,
  useUploadSerialesMutation,
  useGetMdfvByItemMutation,
  useGetMdfvHistorialMutation,
  useSaveMdfvValuesMutation,
  useSaveSerialVarByProductMutation,
  useCheckDuplicatedSerialsVarByProductMutation,
  useCleanSerialesVarByProductMutation,
  useGetCountSerialsVarMutation,
  useDownloadSerialsVarMutation,
  useGetDuplicatedSerialsVarMutation,
  useUpdateSerialVarMutation,
  useSetSerialsPendingVarMutation
} = itemdoxxApiSlice;
